module.exports = __webpack_public_path__ + "static/img/home-bg-image21.2f62c52.png";


//////////////////
// WEBPACK FOOTER
// ./src/newpage/static/images/home-bg-image21.png
// module id = 4NSU
// module chunks = 1